module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.24.0.0.box.415.284.743.295.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.24.0.0.box.581.284.411.39.q.80"
    }
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.24.0.1.box.415.508.743.71.q.80"
    }
  }, [_vm._v("The Seven Days' Battle")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.140.884.1300.1399.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.140.884.1296.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _vm._v("In the opening days of the Civil War, shortly after the Union disaster at First Manassas, morale was high and the South was thought to be invincible.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.189.1072.1203.642.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _vm._v("\"When thirty four year old General George B. McClellan arrived in Washington on July 26, 1861, the streets, bars and hotel lobbies were clogged with soldiers wandering aimlessly in defeat. Even five days after the battle, demoralized Federal officers and men continued to limp across the bridges into the city. On the other side of the river on the rolling plains of Northern Virginia, the victorious Confederates had advanced their outposts to within ten miles of the bridges to Washington. Upstream, cavalry patrols, led by a red-bearded twenty-eight year old colonel, recently a lieutenant in the U.S. Army, J. E. B. Stuart, had appeared near the river. The troopers were fine looking outdoorsmen, mounted on blooded horses and lounging carelessly in the saddles as if watching a sporting event instead of surveying a system of forts (Dowdey, 19).\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.140.1755.1300.420.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.2.0"
    }
  }), _vm._v("But now, almost a year later, things had changed dramatically. With Lincoln's reluctant approval of the Peninsula Campaign, McClellan, commanding the North's largest army, had begun moving his now well-trained, superbly equipped, and generously supplied army to its objective at Fort Monroe. He brought with him over three hundred cannons, mostly twelve-pound brass Napoleons and three-inch ordnance rifles, as well as his own favorite weapons, 100 heavy-siege cannons.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.3.box.140.2185.1300.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.3.0"
    }
  }), _vm._v("The North's movement of the Army of the Potomac from Washington to Fort Monroe was a spectacular accomplishment"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.140.294.1296.531.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("\nthat dwarfed anything done before or during the war. With only a little over five weeks for planning and preparation, Gen. A. L. Tucker, who had been given the assignment, had obtained almost four hundred vessels (113 steamers, 188 schooners, and 88 barges) and moved an army of 121,500 men, 14,592 animals, 44 batteries of artillery and associated wagons, ammunition, and other equipment, with the loss of only eight mules and nine barges. The embarkation began at Alexandria, Virginia on 17 March and the movement was completed by 6 April 1862. The army was subsequently resupplied by sea (Luvaas-Nelson, 271).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.140.294.1297.1989.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.141.835.1295.422.q.60"
    }
  }, [_vm._v("McClellan wasted little time in pursuing the rebels back to the outskirts of Richmond. There, within sight of the spires of the city, his army of 100,000 effectives prepared to dig in. Against this powerful force, Gen. Joseph Johnston, the rebel commander, had barely fifty thousand men. Although the Confederate president, Jefferson Davis, had pleaded earlier with his general to turn and fight, Johnston had declined. In the face of such odds, he would not risk battle until he was ready.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.142.1267.1294.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _vm._v("The Union advance down the Peninsula had not been unopposed, as many Southern units stood and fought bravely before being forced to withdraw. The mission of covering this evacuation and protecting the Confederate rear was the responsibility of J. E. B. Stuart and his six cavalry regiments.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.142.1537.1295.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("Upon discovering the Southern soldiers' evacuation, the Federals put together a pursuit force under Gen. George Stoneman, consisting of four regiments of cavalry and supported by two infantry divisions commanded by Gens. Joe Hooker and Al Smith. Their plan was to attempt to cut off the retreating Southerners and capture all or a portion of their force. Discovering the Union's plan, Stuart deployed his forces along expected enemy avenues of approach, with the objective of making sure that no retreating forces were left behind.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.4.box.143.2022.1293.261.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.4.0"
    }
  }), _vm._v("Stuart displayed great courage and ability in deploying his forces to their full advantage. Repeatedly, his small force would engage superior units and, at the point of being overrun, withdraw under fire to the next delaying position. Due to the marshy nature of the ground, the Union forces pursuing Stuart were"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.138.310.1287.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\nconfined to the roads and, as a result, suffered heavy casualties, in men and horses, from Stuart's artillery.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.136.310.1296.2004.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.136.419.1292.371.q.60"
    }
  }, [_vm._v("In covering the withdrawal, Stuart would need all his talents to protect the rear of the army. The area was enclosed by two broad rivers and threaded throughout with small streams and swamps, which were flooded. Perfectly good roads became bottomless quagmires where men, mules, and guns sank and were virtually immobilized until the rains stopped and the ground had a chance to dry.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.137.800.1295.433.q.60"
    }
  }, [_vm._v("Because of the difficulties Union forces were having on land, an end run was tried on 7 May. The Union force consisting of General Franklin's division was loaded aboard gunboats, then, brought in upstream, behind Southern forces at Eltham's Landing on the York River. Upon discovery, Stuart, with the help of elements from two Southern divisions, made short work of the Federals, driving them back under the protection of their gunboat's covering fire.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.137.1242.1292.373.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("As the Southern states had begun to secede, one at a time, Robert E. Lee had followed his native state, Virginia, into the Confederacy. He then applied to the Southern secretary of war for a commission in the new Confederate army and his request was granted and within a short time, with his seniority and experience, President Davis directed that he be appointed military advisor to the president.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.4.box.138.1625.1291.204.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.4.0"
    }
  }), _vm._v("For the first year of the war, Lee served as spokesman for the president, traveling throughout the South, resolving problems, adjusting troop allotments, requisitioning supplies, and improving defenses that involved more than one major command.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.5.box.136.1837.1293.477.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.5.0"
    }
  }), _vm._v("During his many assignments, Lee was able to see the big picture and also hear the frustrations the Southern president expressed in trying to coordinate defensive efforts among the various states. This was due to the nature of the organization of the Confederacy more than to personalities. From the first, Confederate forces were parceled out among military departments and geographical divisions, each of which, according to a war-office clerk, was \"a separate nation for military purposes, without divisions, cooperation, or concert.\" In the Southern president's concept of a"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.136.321.1295.307.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v("\ncordoned defense, each army, whatever its size or strategic relationship with neighboring forces, was responsible for its own territory. Cooperation with other Confederate armies or military operations against a Union threat was virtually impossible because all interdepartmental correspondence and coordination was routed through Richmond.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.1.0.box.136.321.1301.1992.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.137.650.1298.637.q.60"
    }
  }, [_vm._v("At the beginning of June 1862, things had changed dramatically; these were some of the darkest days of the Confederacy. A pivotal period for the South had begun, with a large federal force in northern Virginia under Gen. Irvin McDowell threatening to move south, and an even larger Union force under Gen. George B. McClellan moving into position on the outskirts of Richmond, for what all considered to be the decisive battle of the war. The Southern forces, in contrast, outnumbered 4 to 1, were scattered and in almost total disarray. It appeared that the war had entered its final phase and would soon be decided in favor of the North, with its overwhelming supply of manpower and equipment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.137.1296.1296.638.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.2.0"
    }
  }), _vm._v("It was at this critical point that Gen. Joseph E. Johnston, commander of the Confederate forces in northern Virginia and those units around Richmond, was seriously wounded while inspecting the front lines. Johnston had been conducting an independent campaign, with no objective in mind beyond the immediate purpose of avoiding combat until he retired into the city of Richmond. But no advantage would be gained by making a stand at Richmond, where no significant fortifications were erected and no forces could be concentrated. With McClellan's army less than eight miles away, a serious dilemma faced the Southern president: Who should be placed in command of the forces defending Richmond for, what was thought to be, the final battle of the war?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.3.box.139.1945.1298.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.3.0"
    }
  }), _vm._v("Davis could appoint one of the subordinate division commanders or he could select his chief military advisor, Gen. Robert E. Lee. After carefully considering the seriousness of the situation, Davis chose Lee, and early on the morning of 1 June 1862, with a small staff, Lee rode out from Richmond to assume command of the Army of Northern Virginia.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.4.box.190.2268.1242.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.4.0"
    }
  }), _vm._v("The new army commander was a quiet, distinguished, Southern"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.0.box.137.311.1293.372.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _vm._v("\naristocrat from the most prestigious of the first families of Virginia. Like his father, the Revolutionary War hero, Henry \"LightHorse Harry\" Lee, he followed a military career. He saw action with Gen. Winfield Scott in Mexico and was present at the capture of John Brown at Harpers Ferry. As an instructor at West Point, he influenced many of the men who later became generals in the Civil War.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.137.311.1297.2006.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.138.705.1291.208.q.60"
    }
  }, [_vm._v("Lincoln had recognized Lee's talents and offered him high command in the Union army. But Lee, rather than stain the sword with the blood of men from his native state, resigned from the Union army to wear the Confederate gray.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.2.box.137.923.1297.535.q.60"
    }
  }, [_vm._v("The unique aspect of Lee's taking command of the Army of Northern Virginia at this low point in the struggle was his unbridled enthusiasm for the attack, for taking the fight to the enemy, his unbelievable willingness to take risks in order to substitute something that his army had plenty of—daring and courage— for the enemy's manpower and equipment, and finally, his supreme confidence that he was better than any Union general who opposed him. These, then, were the rare qualities that would serve him, and the Confederacy, so well during the "), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _vm._v("next three years.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.3.box.137.1468.1293.365.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.3.0.0"
    }
  }), _vm._v("The Seven Days' Battle was just that, a battle that extended over seven days. At the start, President Davis was considering the evacuation of Richmond and preparing for Union soldiers to occupy the city. Contrast this with the last day of the battle, when the Union army was on the run and President Davis was convinced that the South had finally found a commander who could fight and win. The entire South rejoiced with him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.4.box.138.1841.1292.193.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.3.1.0"
    }
  }), _vm._v("The following is a brief summary of that battle, which eventually pitted George B. McClellan, who many considered to be the North's greatest general, against the South's finest, Robert E. Lee.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.5.box.138.2110.1293.207.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.0.0"
    }
  }), _vm._v("The Seven Days' Battle occurred on a long finger of land that extended southeast from Richmond. This finger, or the Peninsula as it was called, was bordered by the York River on the north and the James River on the south. Down the center of the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.0.box.142.296.848.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("\nPeninsula flowed the Chickahominy River.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.141.296.1295.1990.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.141.350.1293.316.q.60"
    }
  }, [_vm._v("McClellan, commanding the North's largest, best-trained, and best-equipped army, had conveniently split his forces, with approximately twenty-five thousand troops north of the Chickahominy River and around eighty-five thousand south of the river, and was making final preparations for his assault on Richmond, which most thought would end the war.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.141.676.1294.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.2.0"
    }
  }), _vm._v("Lee, always the gambler and with the hopelessness of the situation, was ready to take a long chance, with the fate of the South hanging in the balance. He decided to go over to the offensive and concentrate where McClellan was weakest, north of the river. After sending Stuart out to reconnoiter the proposed battle area and then being assured by him that his plan was feasible, Lee began to quickly gather his forces.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.141.1054.1291.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.3.0"
    }
  }), _vm._v("He left 20,000 soldiers south of the Chickahominy to face 85,000 and quietly moved 30,000 men north of the river. These would soon be joined by Gen. Thomas Jackson's, 25,000 men from the Shenandoah Valley, bringing his force north of the Chickahominy to 55,000, facing a Union force of 25,000. This, then, was Lee's concept of the battle, to concentrate where the enemy was weakest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.4.box.143.1432.1292.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.4.0"
    }
  }), _vm._v("This is how things stood on the eve of battle, but let's now take a look at the circumstances that led both sides to this crucial point.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.5.box.142.1646.1294.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _vm._v("McClellan had preferred a series of end runs to a head-to-head confrontation with the Southern army. He thought that by moving quickly, he could cut off the Southern army and, within weeks, force them to surrender. The terrain of the Peninsula would offer numerous opportunities for McClellan to move in behind the Southern army and cut them off.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.6.box.142.1971.1293.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _vm._v("The day after Lee too"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  }), _vm._v("k command he summoned"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.6.0.0"
    }
  }), _vm._v(" all the generals to "), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.8.0.0"
    }
  }), _vm._v("a council of war. The"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.11.0.0"
    }
  }), _vm._v(" division commanders "), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.13.0.0"
    }
  }), _vm._v("were somewhat scandal"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.16.0.0"
    }
  }), _vm._v("ized at what they con"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.17.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.18.0.0"
    }
  }), _vm._v("sidered the risk on L"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.20.0.0"
    }
  }), _vm._v("ee's part for dis"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.22.0.0"
    }
  }), _vm._v("cussing a plan of ope"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.25.0.0"
    }
  }), _vm._v("rations in the presen"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.27.0.0"
    }
  }), _vm._v("ce of the brigadiers."), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.31.0.0"
    }
  }), _vm._v(" They might as well h"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.33.0.0"
    }
  }), _vm._v("ave spared their feel"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.34.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.35.0.0"
    }
  }), _vm._v("ings. Lee simply aske"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.35.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.36.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.37.0.0"
    }
  }), _vm._v("d for opinions on the"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.38.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.39.0.0"
    }
  }), _vm._v(" state of affairs and listened as the brigade"), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.39.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.0.box.143.296.1293.97.q.60"
    }
  }, [_vm._v("\ncommanders reported. He, at last, bade his lieutenants good day, without the slightest intimation of what he intended to do.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.30.0.0.box.138.316.1280.2040.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.141.296.1300.1986.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.142.404.1299.639.q.60"
    }
  }, [_vm._v("The generals rode away, none the wiser for their conference, some of them assured of Lee's ability, others convinced that he had simply called them together to see what manner of men they were. He could hardly have been disappointed in them as a group. The policy of the Davis administration had put at Lee's disposal an unusual number of professional soldiers of high intelligence. Counting those who had yet to join him, Lee was to go into the Seven Days' Battle with forty-nine general officers, whose average age was slightly over forty years. Thirty-one of these were West Point graduates, and only a handful could be counted as \"political generals\" in the accepted Northern use of that unhappy term (Freeman, 190).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.142.1053.1296.367.q.60"
    }
  }, [_vm._v("Lee—realizing that he had, at the most, two weeks before the Union juggernaut put an end to the rebellion—began to organize his plan of action and sent for his young cavalry commander Brig. Gen. J. E. B. Stuart. Stuart was a seasoned cavalry officer, with much experience on the Western frontier, and had performed well in recent battles, with Johnston, giving him major credit for slowing the Union advance.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.144.1429.1294.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.3.0"
    }
  }), _vm._v("Lee's plan included a flanking attack by Gen. Thomas \"Stonewall\" Jackson, through terrain he was unfamiliar with, so Stuart, with a small force of cavalry, was ordered to make a reconnaissance of the route Jackson would take, to check it out.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.4.box.141.1699.1297.368.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0"
    }
  }), _vm._v("Early on the morning of 12 June, as Stuart began his movement, his force consisted of 1,200 cavalry and a section of artillery. The units included the First Virginia Cavalry, commanded by Col. Fitzhugh Lee, nephew of the army commander, and the Ninth Virginia Cavalry, commanded by Col. W. H. F. \"Rooney\" Lee, son of the army commander, plus the Jeff Davis Legion (equal to a large squadron), commanded by Lt. Col. W. T. Martin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.5.box.143.2077.1295.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.1.0"
    }
  }), _vm._v("This daring raid to gather information would bring Stuart notoriety. He moved his little force in the direction of Taylorsville, about twenty-two miles northeast of Richmond. Here, after informing his unit commanders for the first time as to what"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.0.box.141.310.1288.88.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("\ntheir true mission was, he headed his force east, toward the Union lines.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.140.310.1295.1993.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.140.420.1295.314.q.60"
    }
  }, [_vm._v("When Stuart and his men embarked upon their \"ride around,\" as it became known as, a carefree, hellbent-for-leather feeling overcame them and they were invigorated with a constant rush of adventure. It may well have appeared that the force ran in the path of least resistance with little sense of direction, but that would be a false assumption.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.140.744.1291.153.q.60"
    }
  }, [_vm._v("Stuart had carefully planned his route and had guides who were familiar with each part of the movement. Even the river crossing-points had been planned in advance.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.142.907.1290.911.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.3.0"
    }
  }), _vm._v("After causing mass confusion among the Union forces and destroying great quantities of military equipment, the men engaged in the only serious incident that jeopardized the mission: the final crossing of the Chickahominy River. Because of recent rains, the river was swollen and the crossing ford was impracticable. With the Federals close on their heels, the men attempted to swim across and felled trees for a hasty bridge, all without success. Finally, with the arrival of Stuart, scouts were sent up and down the river, with one team quickly reporting the location of a partially burned bridge one mile below the ford. Stuart moved his force on the double and, using materials from a nearby barn, rebuilt the bridge to the point where horses and artillery could pass safely. As the last elements were crossing the bridge, Fitzhugh Lee, with the rear guard, became engaged with an enemy force probing the line. Fitzhugh Lee advanced to attack and the force retired, giving him the opportunity to quickly move his force across the makeshift bridge and to safety.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.4.box.142.1828.1290.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.4.0"
    }
  }), _vm._v("Now over the Chickahominy, at last, the greatest perils of the cavalry expedition were behind them. Still more than thirty miles from Richmond, Stuart turned command of his force over to Col. Fitzhugh Lee and, although he had been in the saddle for over thirty-six hours and covered over 120 miles, rode on ahead to make his report in person to General Lee.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.5.box.143.2152.1287.97.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.5.0"
    }
  }), _vm._v("This daring raid captured the imagination of the people and made Stuart an instant celebrity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.6.box.192.2259.1238.44.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.6.0"
    }
  }), _vm._v("The results of the reconnaissance expedition were impressive"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.140.296.1295.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("\nand General Lee was very pleased. Aside from the destruction wrought and materials captured, the greatest results were those that followed from the information obtained by Stuart. This information, regarding the weakness of McClellan's positions, resolved the question in Lee's mind of whether an attack against Union forces could succeed. He now began to lay out the precise details for the planned offensive against McClellan's forces.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.140.296.1299.1990.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.141.675.1297.315.q.60"
    }
  }, [_vm._v("On the Union side, George Brinton McClellan was the man in whom Lincoln placed his hopes for a quick end to the War of the Secession. The fact that Lincoln and McClellan had been acquainted before the war, when Lincoln was attorney for the railroad of which McClellan was president, had a great deal to do with Lincoln's selection of leader of the army.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.142.1001.1294.852.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.2.0"
    }
  }), _vm._v("Born in Philadelphia, McClellan had led his class at West Point, served ably on General Scott's staff in the Mexican War, and had been sent to observe the European way of war in the Crimea by the then, Secretary of War Jefferson Davis. Most importantly, however, McClellan, a conservative Democrat who wanted to wage war only against the armed defenders of the South and not against the people, had, in 1861, achieved what no other officer had: a victory. His swift campaign in West Virginia was, in itself, of only minor importance, but it had catapulted him to the highest military post in the land. As general in chief, he now drew on the wealth of the nation to equip, train, and reorganize the finest army in the Western Hemisphere, the Army of the Potomac. That army was now centered approximately six to eight miles northwest of Richmond, straddling the Chickahominy River with its larger force on the south side (McLaughlin-Johnson, 13).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.143.1862.1296.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.3.0"
    }
  }), _vm._v("It's important to point out that, at approximately this stage of events, an unknown engineer lieutenant joined McClellan's army on the Peninsula and would soon win great honors and eventually play a significant role in defeating the Army of Northern Virginia. This obscure lieutenant was George Armstrong Custer, who would soon be known for his absolute fearlessness. He began his career with the Army of the Potomac by going aloft in one of the high-risk, hot-air balloons, to report on"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.0.box.88.305.1293.533.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  }), _vm._v("\nenemy positions. The duty had been performed by a general officer, but it was felt that a more expendable man was required. Very soon after this, Custer was asked to accompany the army engineer on a hazardous patrol to explore the Chickahominy River. While on this effort, the general ordered Custer into the river to determine its depth. Custer quickly complied and explored the far side, where he discovered Confederate positions. Later, he was asked to report personally to General McClellan, who was so impressed with the young man that he asked him to join his staff.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.88.305.1298.1986.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.91.848.1291.745.q.60"
    }
  }, [_vm._v("As the two sides prepared for battle, an unusual event occurred. Between the two wings of McClellan's army ran the Richmond and York Railroad, which, crossing the river at Dispatch Station, was connected by the new spur to McClellan's headquarters at White House Landing on the Pamunkey River, about twenty miles east of Richmond. The White House plantation had been the home of Martha Custis when she married George Washington, and the property had been inherited by her great, great-grandson, W. H. F. \"Rooney\" Lee, General Lee's son and a colonel in Stuart's cavalry. Mrs. Robert E. Lee had been in residence there when the Federal troops took possession, and through those gallantries typical of McClellan, the partly crippled lady had been ceremoniously escorted through the lines (Dowdey,77).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.2.box.91.1603.1294.311.q.60"
    }
  }, [_vm._v("As the start of the battle approached, there was concern that Gen. Ambrose Burnside's Federal army from North Carolina would combine with McClellan's, making the odds against Lee overwhelming. As it stood, Lee had planned to field an army of approximately seventy-five thousand against McClellan's 150,000 but he needed to act quickly before these figures changed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.3.box.91.1924.1295.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.3.0"
    }
  }), _vm._v("In order to assemble as large a force as possible to oppose McClellan, Lee had obtained President Davis's permission to utilize the ragtag forces defending Richmond, approximately eight thousand men. However, Davis had required the construction of trenches and fortifications to protect the men on the line. So, for the next few days, Lee devoted himself to expediting the construction of these defenses. Scorning the shelter of fortifications"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.1.0.box.140.294.1296.799.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _vm._v("\nas unworthy of gentlemen in arms, the troops were not disposed to constructing them; they did grumble at the orders of their engineer general, the King of Spades, as they dubbed him. Lee did not stand back because of antagonism or doubting minds. Almost daily, he went out to the lines, encouraging the soldiers and complimenting them on their progress. The work began to rise satisfactorily, not a strong line, but ample for the immediate purpose. Lee also used this time to stiffen discipline and improve the organization of the army. The obstacles were many. In some aspects, discipline had been lax under Johnston; drunkenness had been frequent, and many things were at loose ends. Lee worked as fast as he could to improve the condition of the men. The commissary and the quartermaster's service were improved. Favoritism in granting details for service in the rear was ended (Freeman, 189-90).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.140.294.1297.1991.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.142.1108.1294.247.q.60"
    }
  }, [_vm._v("Meanwhile, McClellan's only reason for not attacking was that the rainy season had begun and the roads were a quagmire and area streams too swollen for movement. But now, at last, the ground was starting to dry and nearby streams returning to their banks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.140.1377.1297.583.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.2.0"
    }
  }), _vm._v("On 25 June 1862, Lee launched his attack and the battle began with great promise. Then the couriers started arriving with reports of delays and confusion; it seemed that everything that cou"), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.4.0"
    }
  }), _vm._v("ld go wrong, did go wrong. It was well after three o'clock in the afternoon when the first shots were heard, announcing the opening of hostilities. Unbelievably, as Gen. John B. Magruder's 20,000 Confederates south of the river began attacking the 80,000 Federals opposite them, the Union force began to withdraw. It appeared that Federal units had planned a withdrawal in the face of Confederate strength and were simply being pursued by what they thought was a superior force of Confederate infantry.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.3.box.141.1969.1295.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.5.0"
    }
  }), _vm._v("The Confederates had successfully convinced the Federals that they were opposed by a much larger Southern force. This deception had been the work and inspiration of the Confederacy's distinguished amateur actor, Gen. John Bankhead Magruder, who was having just the kind of time for himself he'd had at Yorktown holding a thin line. Magruder had been"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.136.308.1296.644.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _vm._v("\nexceedingly nervous. His twenty thousand men were all that stood between McClellan's 85,000 bluecoats and Richmond, for over forty-eight hours, and Magruder was very much aware that if the Yankees caught on there was little he could do to keep them from rolling right over him and going into the capitol of Richmond. So he had played the game with every variation of which he could. Regiments had gone out into open spaces to march and countermarch and look numerous, and officers had stood in the woods, shouting commands to completely imaginary brigades. Picket lines and patrols had been kept visibly active, as if making preparations for a huge attack. In the end, it had worked (Catton, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mr. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lincoln's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Army, ")]), _vm._v("82).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.136.308.1296.1992.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.138.962.1291.152.q.60"
    }
  }, [_vm._v("The major part of Lee's plan north of the river was never executed, primarily because Jackson did not, for various reasons, participate in the battle on this day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.138.1124.1291.210.q.60"
    }
  }, [_vm._v("Jackson's participation was key to the operation's success; however, without explanation, when his forces arrived in the battle area, rather than attacking, as the plan called for, he ordered his troops into bivouac as they came up.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.3.box.136.1343.1293.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.3.0"
    }
  }), _vm._v("As the men started making camp, after six o'clock, the firing ahead grew in intensity, and Jackson's staff saw that he looked worried. However, it was too late to do anything about it then, even if they had known what to do. The incredible thing was that Stonewall Jackson, of the lightning marches and the sudden strokes, bivouacked his valley army without sending forward a line of skirmishers or giving an order for the next day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.4.box.137.1721.1292.579.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.4.0"
    }
  }), _vm._v("Modern historians can easily see that Jackson was suffering from something that was unknown at the time, stress fatigue. He had been under stress continuously for fifty-eight days when he reached the battle area on 26 June. It was intensified when he foolishly made the fourteen-hour night ride to Richmond from 1:00 A.M. to late afternoon on the twenty-third, and then, without rest or food, taking only a glass of milk, making the return ride through a second night from about seven in the evening until midmorning of the twenty-fourth. His judgment had already been affected when he made the all-night rides on successive nights. To a person in possession of his faculties, the strain to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.136.318.1297.98.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  }), _vm._v("\nwhich he exposed his body would have been regarded as irresponsible.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.136.318.1302.1983.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.137.426.1295.196.q.60"
    }
  }, [_vm._v("Rather than attacking as ordered, Jackson sat in a stupor, while his army, because of the way he had organized and trained it, sat waiting for his instructions, as the battle raged all around them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.2.box.139.644.1294.150.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.2.0"
    }
  }), _vm._v("Of Lee's assembled forces, only approximately fourteen thousand participated in the battle and his assessment was that the day had been a dismal failure.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.3.box.138.804.1300.851.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.3.0"
    }
  }), _vm._v("On the second day of the battle, Lee made his greatest gains. He had drafted a plan to cut off the withdrawing enemy and at least destroy a portion of the army. Jackson was again slow to move and the enemy in his sector escaped to the protection of Confederate gunboats. But this day saw some of its most desperate fighting around Nelson's Farm, where Gen. George G. Meade, the future commander of the Army of the Potomac, fell wounded. In this fight, reserves came up from Gen. Phil Kearny and the battle over the captured guns resolved into one of the infrequent bayonet fights of the war. It was savage action in the small clearing in front of the Nelson farmhouse, with men going down with as many as three bayonet thrust in their bodies, some, were knocked senseless by rifle butts. In the confusion, with giving up the barren ground and the scattering of Kearny's supporting division, many of the captured Union guns were lost to Gen. George A. McCall (Dowdey, 300).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.4.box.138.1664.1297.478.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.4.0"
    }
  }), _vm._v("Lee had succeeded in driving the Federals away from Richmond and would continue to pursue them for four more days as they streamed back to the protection of their gunboats. It had worked because McClellan and his corps commanders were convinced (based upon intelligence reports from Pinkerton's Detectives) that Lee had close to two hundred thousand men on the field, and it was possible for him, as it seemed to them, to use sixty thousand or more to crush Gen. Fitz-John Porter, north of the river and still retain overwhelming numbers on the south side.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.5.box.141.2151.1294.150.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.5.0"
    }
  }), _vm._v("Although Lee was unhappy with the performance of his generals and the plan never quite came together as he intended, the Southern president and the people were overjoyed with the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.138.309.1290.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _vm._v("\nresults and treated Lee as the savior of Richmond for driving the Federal forces away. Despite the difficulties, he had gained the trust and confidence of his men and their faith in him was unbounded.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.137.309.1297.1994.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.138.535.1290.266.q.60"
    }
  }, [_vm._v("The battle also provided Lee with the opportunity to evaluate his commanders and he used the occasion to reorganize his army, sending two overly cautious division commanders to the trans-Mississippi department. Then, he formed two corps, to make the army more responsive and Lee's job easier.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.2.box.137.812.1297.914.q.60"
    }
  }, [_vm._v("Lee had not given up on Jackson. His reputation of success in battle demanded that he be given one more chance. Maj. Gen. Thomas Jonathan Jackson earned his nickname of Stonewall at the First Battle of Bull Run, where his brigade, standing \"like a stonewall,\" formed the rallying point for the wavering rebel army. That was only the first of many actions in which Jackson, a west Virginian and ex-professor at the Virginia Military Institute, combined the qualities of a religious mystic with those of a hardened warrior knight and contrived a miraculous victory for an outnumbered Confederate force. In the Shenandoah Valley, with fewer than twenty thousand men, he had fought a half-dozen major battles against an army three times his size, winning every engagement and marching with such incredible speed that his opponents dubbed his troops, \"Jackson's foot cavalry.\" His corps did more to defeat the Union armies in 1862 and 1863 than any comparable body of men in the entire war (McLaughlin-Johnson, 76).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.3.box.138.1735.1294.568.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.3.0"
    }
  }), _vm._v("Another reason for keeping Jackson was his daring proposal for taking the war to the north. It was while he was still in the Shenandoah Valley that Jackson sent a messenger with a startling proposal for Lee, who was then serving as military advisor to President Davis. Jackson proposed that his forces be increased to 40,000, and with the additional men, he would invade the North and relieve the pressure on Richmond. This was the first time an invasion of the North had been proposed to Lee and he saw immense possibilities for an offensive into the North. After discussing Jackson's message with his staff, Lee wrote the following letter to President Davis:")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.1.0.box.140.295.1299.1987.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.0.box.190.295.1194.341.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("\"I think if it was possible to reinforce Jackson strongly, it would change the character of the war. This can only be done, by assigning to him the troops in Georgia, South Carolina and North Carolina, then Jackson could in that event cross Maryland into Pennsylvania. It would call all the enemy, from our Southern coast and liberate those states. If these states will give up their troops, I think it can be done.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.140.674.1294.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0"
    }
  }), _vm._v("Prior to this time, Lee had held strictly to the defensive, but now he began to consider, as he called it, an \"offensive defensive.\" Davis was intrigued by the concept but, because of the states' rights, was unable to persuade all the states into parting with their protecting forces. Although disappointed, Lee did not completely give up on the idea of an offensive into Pennsylvania and, during the next several months, returned to it often as a future operation that could change the outcome of the war.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.2.box.140.1106.1294.410.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.2.0"
    }
  }), _vm._v("After the success of the Seven Days' Battle, Lee began to shape a method of operation that would continue throughout the duration of the war. It would be his policy to engage the Federals as far away from Richmond as possible and on the approaches to Washington, if possible. The concept of taking the war to the North was another important consideration that would increase in importance as the South's ability to wage war decreased.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.3.box.141.1537.1298.745.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.3.0"
    }
  }), _vm._v("The tangible results of the Seven Days' Battle were obvious: the whole plan of Federal operations in Virginia had been disrupted after the Confederates' defeat had seemed inevitable. On 26 June, McClellan's army of 150,000 effectives had been like a sharpened sickle, ready to sweep over Richmond. Now, it was crowded into an entrenched camp eighteen miles away, cowering under the protection of its gunboats. Fifty-two fine Federal guns were in Confederate hands, 10,000 prisoners had been captured, and upward of thirty-one thousand muchneeded small arms were gleaned from the fields. \"The siege of Richmond was raised,\" Lee reported, \"and the object of the campaign which had been prosecuted after months of preparation at an enormous expenditure of men and money, completely frustrated.\"")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.136.310.1297.2003.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.0.box.137.310.1293.541.q.60"
    }
  }, [_vm._v("Yet, too many Confederate dead were buried between Mechanicsville and Malvern Hill, and too many men lay wretched in the hospitals for Lee to feel any elation. Of the 85,500 men with whom he had begun the campaign, 3,286 were dead, 15,909 were wounded, and 946 were missing, a total of 20,141. Approximately half of the wounded were doomed to die or to be permanently incapacitated from field duty. In other words, 11,000 men, the first line of the South, had been lost to the Confederacy for all time. Federal losses were assumed to be higher, but actually, they were less by nearly 4,300.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.138.861.1292.210.q.60"
    }
  }, [_vm._v("Lee had achieved less than he had hoped and less than he believed he should have accomplished. \"Under ordinary circumstances,\" he stated in his report, \"the Federal army should have been destroyed (Freeman, 221).\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.136.1081.1297.1232.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.2.0"
    }
  }), _vm._v("Lee gave little time and less thought to reading the newspapers, which were discounting his performance or sounding his praises. His immediate task was to reorganize the army. The most pressing part of that task was to provide better divisional leadership. Among his lieutenants, Gen. James Longstreet had emerged as the most dependable. However, there remained Jackson; what should be done about him? By every test, Jackson had failed throughout the seven days. Had Jackson fought as hard and done as well as Longstreet and A. P. Hill? There may have been a different tale to tell. Lee may have felt this, but he never had the slightest doubt concerning Jackson's ability, his discretion, or his daring independent command, yet he may have feared that Jackson was too ambitious and ill-disposed to fight under another commander. Jackson did have to his credit the amazing campaign in the valley, which had shown of what he was capable. Lee could not overlook past performance. He retained his faith in Jackson, but he made a significant change in the organization of the army. He left Lawton's brigade to fill out Jackson's old division and retained Gen. Richard S. Ewell under the control of Jackson. Thus, if required for separate use, the army of the valley was intact. Gen. Chase Whiting's division was joined with Gen. Theophilus Holmes' former force under Gen. D. H. Hill. The rest of the infantry divisions were entrusted to Longstreet. Jackson fought"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.135.320.1304.425.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _vm._v("\nthe Seven Days' Battle with fourteen brigades. In the reorganization, he was allotted seven. Longstreet had carried six brigades across the Chickahominy, he soon had twenty-eight. What did Jackson think of all of this? He never told anyone that he felt he had failed to do his part in the campaign. His report contained no apologies. If he did not blame himself, however, it is certain he did not blame Lee or criticize the distribution of forces (Freeman, 223).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.135.320.1304.1020.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.144.759.1295.581.q.60"
    }
  }, [_vm._v("Lee came gradually to act as his own chief of staff. It seems strange, at first glance, that a man so mindful of the value of military details could have done so little to prepare maps, to make his artillery more efficient, or to build up his staff. Lee, however, realized that Confederate success depended on utilizing the means at hand, without waiting to perfect them in competition with an enemy whose resources were far greater. Whatever the Southern states could hope to do had to be done quickly. Lee had to leave much to chance and more to the accumulating experience of the army, as he prepared for a dramatic new stage of the war in Virginia (Freeman, 224).")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4880fa21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0012.vue
// module id = 66
// module chunks = 0